import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/libs/cb-static/cb.util'
import '@/libs/cb-static/sprintf.min'
import '@/libs/cb-static/cb.date'
import 'leaflet/dist/leaflet.css'
import 'leaflet/dist/leaflet-src.js'
import './index.css'
import '@/libs/cb-theme'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
